import React, { useState } from 'react';

import DocChunkBrowser from './doc-chunk-browser';
import FactBrowser from './fact-browser';

interface CitationAssignerProps {
  caseId: string;
  selectedCitation: string;
  onAssign: (id: string, type: 'fact' | 'chunk') => void;
  currentlyAssignedId?: string;
  currentlyAssignedType?: 'fact' | 'chunk';
}

type TabType = 'fact' | 'doc';

const CitationAssigner: React.FC<CitationAssignerProps> = ({
  caseId,
  selectedCitation,
  onAssign,
  currentlyAssignedId,
  currentlyAssignedType,
}) => {
  const [activeTab, setActiveTab] = useState<TabType>('fact');

  return (
    <div className="flex h-full flex-col">
      {/* Header with Tab Switcher */}
      <div className="mb-3 flex items-center justify-between gap-3">
        <h3 className="text-sm font-semibold text-gray-700">Assign Citation [{selectedCitation}]</h3>

        {/* Tab Switcher */}
        <div className="flex gap-1 rounded-lg bg-gray-100 p-1">
          <button
            onClick={() => setActiveTab('fact')}
            className={`rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
              activeTab === 'fact' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Fact
          </button>
          <button
            onClick={() => setActiveTab('doc')}
            className={`rounded-md px-3 py-1.5 text-xs font-medium transition-colors ${
              activeTab === 'doc' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-600 hover:text-gray-900'
            }`}
          >
            Chunk
          </button>
        </div>
      </div>

      {/* Tab Content */}
      <div className="flex-1 overflow-hidden">
        {activeTab === 'fact' ? (
          <FactBrowser onSelectFact={(factId) => onAssign(factId, 'fact')} />
        ) : (
          <DocChunkBrowser
            caseId={caseId}
            onSelectChunk={(chunkId) => onAssign(chunkId, 'chunk')}
            currentlyAssignedChunkId={currentlyAssignedType === 'chunk' ? currentlyAssignedId : undefined}
          />
        )}
      </div>
    </div>
  );
};

export default CitationAssigner;
